module.exports = __webpack_public_path__ + "static/media/Logo.9e21927f.png";